import { Icon, Tooltip, Typography } from "@kyan/ui";
import Link from "next/link";

import { routes } from "#/config/routes";

interface LimitPriceInputTooltipProps {
  label: string;
}

export const LimitPriceInputTooltip: React.FC<LimitPriceInputTooltipProps> = ({
  label,
}) => {
  return (
    <div className="flex items-center gap-2">
      <span>{label}</span>

      <Tooltip
        avoidCollisions
        side="right"
        align="center"
        content={
          <div className="m-1 grid gap-3">
            <Typography primary size={12}>
              Default price applies slippage to mark price.
            </Typography>
            <div className="grid gap-1">
              <Typography size={12}>Go to the settings page to</Typography>
              <Link
                className="decoration-primary"
                href={routes.portfolio.settings + "#slippage"}
              >
                <Typography
                  size={12}
                  className="text-brandBlue hover:text-primary transition-colors"
                >
                  Manage slippage for this option delta.
                </Typography>
              </Link>
            </div>
          </div>
        }
      >
        <Icon size="xs" name="question" className="text-textSecondary" />
      </Tooltip>
    </div>
  );
};
